<div class="nav-wrap">
  <img class="logo" src="../../../../assets/images/logos/ca_us/InsureShield_Logo_226x79_larger_tagline-01.png" alt="{{ 'billing.method.altUps' | translate }}">
</div>
<div class="main">
  <div class="loading" *ngIf="loading">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="main-card-wrapper" *ngIf="!loading">
    <div class="red ml-3" *ngIf="systemError || nullTokenClaims">
      {{ 'common.systemError' | translate }}
      <button class="upsc-primary-button mt-3" (click)="logout()">{{ 'app.header.accountitems.logout' | translate }}</button>
    </div>
  </div>
  <div *ngIf="accessPending" class="access-pending">
    <div class="title">{{ 'payee.denied.pending' | translate }}</div>
    <div class="description">{{ 'payee.denied.pendingAccess' | translate }}</div>
  </div>
  <div *ngIf="accessDenied" class="access-denied">
    <div class="title">{{ 'payee.denied.accessDenied' | translate }}</div>
    <div class="description">{{ 'payee.denied.appDenied' | translate }}</div>
  </div>
</div>
<div class="footer">
  <upsc-footer></upsc-footer>
</div>